import React, { createContext, useContext } from 'react';
import useReducerHook from 'src/hooks/reducer.hook';
import UtilReducer, {
  defaultState,
  asyncActions,
} from 'src/ducks/util.duck';

// We need to do this, to be able to get the typings of the Reducer
const useReducer = () => {
  return useReducerHook(UtilReducer, defaultState, asyncActions);
};

type IUtilContext = ReturnType<typeof useReducer>;

// Having trouble setting initial values, that's why it is cast to the return type of the reducer
const UtilContext = createContext<Partial<IUtilContext>>({
  state: defaultState,
}) as React.Context<IUtilContext>;

const UtilProvider: React.FC = ({ children }) => {
  const reducer = useReducer();

  return (
    <UtilContext.Provider
      value={{
        ...reducer,
      }}
    >
      {children}
    </UtilContext.Provider>
  );
};

// We create context hook here so that we can able to unit test
// container components that uses this context
export const useUtilContext = () => useContext(UtilContext);

export type IUseUtilContext = ReturnType<typeof useUtilContext>;

export { UtilContext, UtilProvider };
